import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';
import { buttons, textblocks } from 'seal-ui-components';

export default css`
    position: relative;
    padding: 0rem ${getBaseTheme().spaces.inline.xs} ${getBaseTheme().spaces.inline.xs};
    ${textblocks.Label} {
        font-size: ${getBaseTheme().texts.sizes.xs.fontSize};
    }
    ${buttons.Button} {
        text-transform: none;
    }
    .Box.HorizontalBox {
        position: static;
    }
`;
